import { get } from '../api';

const route = '/search';

const getSearchAnalysis = ({ id, searchString = '', config }) =>
  get(`${route}/${id}/explain?${searchString}`, config);

export default getSearchAnalysis;
